import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GhostwriterViewerConsentStatusQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GhostwriterViewerConsentStatusQuery = { __typename?: 'Query', ghostwriter: { __typename?: 'GhostwriterQueries', viewer: { __typename?: 'GhostwriterViewer', consentStatus: boolean } } };


export const GhostwriterViewerConsentStatusDocument = gql`
    query GhostwriterViewerConsentStatus {
  ghostwriter {
    viewer {
      consentStatus
    }
  }
}
    `;

/**
 * __useGhostwriterViewerConsentStatusQuery__
 *
 * To run a query within a React component, call `useGhostwriterViewerConsentStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGhostwriterViewerConsentStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGhostwriterViewerConsentStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGhostwriterViewerConsentStatusQuery(baseOptions?: Apollo.QueryHookOptions<GhostwriterViewerConsentStatusQuery, GhostwriterViewerConsentStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GhostwriterViewerConsentStatusQuery, GhostwriterViewerConsentStatusQueryVariables>(GhostwriterViewerConsentStatusDocument, options);
      }
export function useGhostwriterViewerConsentStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GhostwriterViewerConsentStatusQuery, GhostwriterViewerConsentStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GhostwriterViewerConsentStatusQuery, GhostwriterViewerConsentStatusQueryVariables>(GhostwriterViewerConsentStatusDocument, options);
        }
export function useGhostwriterViewerConsentStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GhostwriterViewerConsentStatusQuery, GhostwriterViewerConsentStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GhostwriterViewerConsentStatusQuery, GhostwriterViewerConsentStatusQueryVariables>(GhostwriterViewerConsentStatusDocument, options);
        }
export type GhostwriterViewerConsentStatusQueryHookResult = ReturnType<typeof useGhostwriterViewerConsentStatusQuery>;
export type GhostwriterViewerConsentStatusLazyQueryHookResult = ReturnType<typeof useGhostwriterViewerConsentStatusLazyQuery>;
export type GhostwriterViewerConsentStatusSuspenseQueryHookResult = ReturnType<typeof useGhostwriterViewerConsentStatusSuspenseQuery>;
export type GhostwriterViewerConsentStatusQueryResult = Apollo.QueryResult<GhostwriterViewerConsentStatusQuery, GhostwriterViewerConsentStatusQueryVariables>;